const login = {
  'login.loginTitle': 'Вход в аккаунт',
  'login.username.placeholder': 'Логин',
  'login.password.placeholder': 'Пароль',
  'login.login': 'Войти',
  'login.msg.empty': 'Логин или пароль не могут быть пустыми',
  'login.msg.loginfail': 'Ошибка входа',
  'login.img': 'https://fe-static.cassmall.com/assets/images/20250303140619/login_bg_ru.jpg',
  'login.msg.accountEmpty': 'Логин пуст',
};

export default login;
